module.exports = __webpack_public_path__ + "img/instagram.82ae5657.png";